<template>
  <div>
    <div class="d-flex justify-content-center align-items-center w-100 h-100 font-large-2">
      Word
    </div>

    <div v-if="word.id">
        <div class="word">
          word - {{word.title}}
          <br>
          translation - {{word.translation}}
          <br>
          description - {{word.description}}
          <br>
          example - {{word.example}}
          <br>
          example translation - {{word.example_translation}}
          <br>
          <div>
            <h2>Prononcuation</h2>
            <audio controls>
              <source :src="`${backEndUrl}/${word.voice_url}`" type="audio/ogg">
              Your browser does not support the audio element.
            </audio>
          </div>
        </div>
    </div>




  </div>
</template>

<script>
import {backEndUrl} from '@/helpers/consts';
import letters from "@/api/letters";

export default {
  name: "index",
  data() {
    return {
      word: [],
      backEndUrl,
    }
  },
  created() {
    letters.getWord(this.$route.params.id)
        .then(res => {
          this.word = res.data
        })
        .catch(err => {
          console.log(err)
        })
  }
}
</script>

<style scoped>
.word{
  padding: 5px 10px;
  border: 1px solid #ffbd3b;
  margin-right: 10px;
}
</style>
